import { z } from "zod";

export const getHeadcountRequestSchema = z.object({
  start_date: z.string(),
  end_date: z.string(),
  include_employees: z.boolean().default(true),
  include_contractors: z.boolean().default(true),
  bucket: z.enum(["week", "month", "quarter"]).default("month"),
  include_series: z.boolean().default(true),
});

export type TGetHeadcountRequest = z.infer<typeof getHeadcountRequestSchema>;

const headcountBreakdownSchema = z.object({
  workers: z.number(),
  contractors: z.number(),
  total: z.number(),
});

export type THeadcountBreakdown = z.infer<typeof headcountBreakdownSchema>;

const headcountBucketSchema = z.object({
  bucket_start: z.string(),
  bucket_end: z.string(),
  new_count: z.number(),
  terminated_count: z.number(),
  net_change: z.number(),
  ending_headcount: z.number(),
});

export type THeadcountBucket = z.infer<typeof headcountBucketSchema>;

export const getHeadcountResponseSchema = z.object({
  window: z.object({
    start_date: z.string(),
    end_date: z.string(),
    bucket: z.string(),
  }),
  summary: z.object({
    starting_headcount: headcountBreakdownSchema,
    ending_headcount: headcountBreakdownSchema,
    new_count: headcountBreakdownSchema,
    terminated_count: headcountBreakdownSchema,
    net_change: headcountBreakdownSchema,
  }),
  series: z.array(headcountBucketSchema).optional(),
});

export type TGetHeadcountResponse = z.infer<typeof getHeadcountResponseSchema>;
